import date from 'date-and-time';

/**
 * The release day of "On a date" (QA 2026-10-28, brk-10): today or later, and at most two years
 * ahead. A past day has nothing to count down to; a typo year (9999) gave a countdown of millions
 * of days. music24-api checks the same range (`Catalog/utils/releaseDateRange.ts`).
 */
export const RELEASE_DAY_MAX_YEARS_AHEAD = 2;

export type ReleaseDayProblem = 'missing' | 'past' | 'tooFar';

/** The last day that "On a date" takes, as `YYYY-MM-DD` (the `max` of the date field). */
export function lastReleaseDay(today: string): string {
  return date.format(date.addYears(date.parse(today, 'YYYY-MM-DD'), RELEASE_DAY_MAX_YEARS_AHEAD), 'YYYY-MM-DD');
}

/** The problem of a `YYYY-MM-DD` day against `today` (`YYYY-MM-DD`), or null. */
export function releaseDayProblem(day: string, today: string): ReleaseDayProblem | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) {
    return 'missing';
  }
  if (day < today) {
    return 'past';
  }
  return day > lastReleaseDay(today) ? 'tooFar' : null;
}
